import React from 'react';
import { VerticalEmbedViewer } from '../viewer/vertical-embed-viewer.js';
import 'classnames';
import 'ricos-context';
import 'wix-rich-content-common';
import '../CardContent-2e468947.js';
import 'prop-types';
import 'wix-rich-content-common/libs/Tooltip';
import '../components/Card.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../dataHooks.js';
import '../types.js';
import '../viewer/verticalsDataBuilder.js';
import '../convertDuration.js';
import 'lodash';

const AppEmbed = ({ settings, componentData }) => {
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(VerticalEmbedViewer, { componentData, settings, helpers: {} }));
};

export { AppEmbed };
//# sourceMappingURL=component.js.map
